"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowTaskSurvey () {
        return AutoflowTaskSurvey;
    },
    get AutoflowTaskSurveyOpenEmail () {
        return AutoflowTaskSurveyOpenEmail;
    },
    get AutoflowTaskSurveyOpenEmailResponse () {
        return AutoflowTaskSurveyOpenEmailResponse;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _surveys = require("../../surveys");
const _taskbase = require("./task-base");
const AutoflowTaskSurveyOpenEmail = _taskbase.AutoflowTaskBase.extend({
    task_type: _zod.z.literal("survey:open-email"),
    config: _zod.z.object({
        survey_id: _zod.z.instanceof(_bson.ObjectId),
        user_id: _zod.z.instanceof(_bson.ObjectId),
        url_prefix: _zod.z.string(),
        participants: _zod.z.array(_surveys.SurveyParticipantModel).nullish()
    })
});
const AutoflowTaskSurveyOpenEmailResponse = _taskbase.AutoflowTaskBaseResponse.extend({
    task_type: _zod.z.literal("survey:open-email")
});
const AutoflowTaskSurvey = _zod.z.discriminatedUnion("task_type", [
    AutoflowTaskSurveyOpenEmail
]);
